/**
 * The two glyphs this feature draws, matching the stroke weight and the 16px
 * box every other icon in this app uses (`src/components/catalog/icons`).
 *
 * `aria-hidden` on both: each is mounted beside real text that already names
 * the thing, and an icon that repeats its own label is a second announcement
 * for a screen reader rather than a second signal.
 */

/** The feature's own mark — a form that has been filled in and sent. */
export function EventInterestIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="h-4 w-4"
    >
      <path d="M5 4h9l5 5v11H5V4Z" />
      <path d="M14 4v5h5" />
      <path d="M9 13h6M9 16.5h4" />
    </svg>
  );
}

/** A stop on a tour, for the demand-by-city surface. */
export function CityDemandIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="h-4 w-4"
    >
      <path d="M12 21s6.5-6.1 6.5-10.5a6.5 6.5 0 1 0-13 0C5.5 14.9 12 21 12 21Z" />
      <circle cx="12" cy="10.5" r="2.25" />
    </svg>
  );
}
